import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { receiptImage, downloadReceipt } from '../lib/receiptImage';
import { nativeFile, nativeFilesAvailable } from '../lib/androidApp';

export const useReceiptShare = (receiptRef, identity, reference) => {
  const [prepared, setPrepared] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let active = true;
    setPrepared(null); setError('');
    receiptImage(receiptRef.current, reference).then(file => {
      if (active) setPrepared({ identity, file });
    }).catch(() => { if (active) setError('Receipt image could not be prepared. Please retry.'); });
    return () => { active = false; };
  }, [receiptRef, identity, reference, revision]);
  const file = prepared?.identity === identity ? prepared.file : null;
  const download = async () => {
    if (!file || busy) return;
    setBusy(true);
    try {
      if (!await nativeFile('download', file, file.name)) downloadReceipt(file);
      toast.success('Receipt image saved');
    } catch (failure) { if (failure.name !== 'AbortError') toast.error(failure.message || 'Receipt could not be saved.'); }
    finally { setBusy(false); }
  };
  const share = async () => {
    if (!file || busy) return;
    setBusy(true);
    try {
      if (nativeFilesAvailable()) await nativeFile('share', file, file.name);
      else if (navigator.share && navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], title: `MALDHOWR receipt ${reference}` });
      } else { downloadReceipt(file); toast.success('Receipt image downloaded'); }
    } catch (failure) {
      if (failure.name !== 'AbortError') toast.error('Sharing is unavailable. Use Download receipt instead.');
    } finally { setBusy(false); }
  };
  return { ready: !!file, busy, error, share, download, retry: () => setRevision(value => value + 1) };
};